var React = require('react');

function ShoppingCart (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(1 1)","stroke":"#91D3CA","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("circle",{"cx":"6.182","cy":"15.238","r":"1","key":0}),React.createElement("circle",{"cx":"14.682","cy":"15.238","r":"1","key":1}),React.createElement("path",{"d":"M0 0h3.09l2.072 10.202a1.54 1.54 0 001.545 1.227h7.511a1.54 1.54 0 001.546-1.227L17 3.81H3.864","key":2})]));
}

ShoppingCart.defaultProps = {"width":"19","height":"18"};

module.exports = ShoppingCart;

ShoppingCart.default = ShoppingCart;
